/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayTeamMetricsDtoSchema } from "./goodLuck/core/DTOs/replayTeamMetricsDtoSchema.ts";
import { z } from "zod/v4";

export const getTournamentsTournamentidTeamStatsReplaysPathParamsSchema =
  z.object({
    tournamentId: z.string(),
  });

/**
 * @description OK
 */
export const getTournamentsTournamentidTeamStatsReplays200Schema = z.array(
  z.lazy(() => goodLuckCoreDTOsReplayTeamMetricsDtoSchema),
);

export const getTournamentsTournamentidTeamStatsReplaysQueryResponseSchema =
  getTournamentsTournamentidTeamStatsReplays200Schema;
